import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class BulkImportMedical extends DynamicFieldsSerializer {}
